import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Chart, registerables } from "chart.js";
import "./styles/variables.css";
import App from "./App";
import "./styles/base.css";
import "./styles/tailwind.css";
import "./styles/heroui-theme.css";

Chart.register(...registerables);

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element not found");
}

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
